import { makeApi } from "@zodios/core";
import { z } from "zod";

export const backofficeEmailApi = makeApi([
  {
    method: "get",
    path: "/site/:siteId/subscriber/:subscriberId/last-sending-datetime-for-invalid-pdl-email",
    response: z.coerce.date().nullable(),
    alias: "findLastSendingDatetimeForInvalidPdlEmail",
  },
  {
    method: "post",
    path: "/site/:siteId/subscriber/:subscriberId/send-ask-electricity-contract-mail",
    response: z.any(),
    alias: "sendAskElectricityContractMail",
  },
  {
    method: "post",
    path: "/site/:siteId/subscriber/:subscriberId/document/:documentId/send",
    alias: "sendDocumentByMailToSubscriber",
    parameters: [
      {
        name: "siteId",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "subscriberId",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "documentId",
        type: "Path",
        schema: z.number(),
      },
    ],
    response: z.unknown(), // 200 ok
  },
]);
